import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiGlobe } from 'react-icons/fi';

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇲🇽' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' }
];

const LanguageGate = ({ onSelect }) => {
  return (
    <div className="fixed inset-0 z-[9999] bg-black flex flex-col items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center max-w-2xl w-full"
      >
        <div className="mb-8 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-mx-green via-white to-mx-red opacity-20 blur-3xl rounded-full"></div>
          <h1 className="text-5xl md:text-7xl font-serif font-black text-white mb-2 relative z-10">
            EYELASHES<span className="text-mx-green">MEXICO</span>
          </h1>
          <p className="text-mx-gold tracking-[0.3em] uppercase text-sm md:text-base relative z-10">
            Official Eyelash Extensions of Mexico
          </p>
        </div>

        <h2 className="text-white text-xl mb-8 font-light">Select Your Language / Seleccione Su Idioma</h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {languages.map((lang) => (
            <motion.button
              key={lang.code}
              whileHover={{ scale: 1.05, borderColor: '#D9A441' }}
              whileTap={{ scale: 0.95 }}
              onClick={() => onSelect(lang.code)}
              className="border border-white/20 bg-white/5 backdrop-blur-sm rounded-xl p-6 flex flex-col items-center gap-3 hover:bg-white/10 transition-colors group"
            >
              <span className="text-4xl shadow-xl">{lang.flag}</span>
              <span className="text-white font-medium tracking-wide group-hover:text-mx-gold transition-colors">
                {lang.name}
              </span>
            </motion.button>
          ))}
        </div>

        <div className="mt-12 text-gray-500 text-xs uppercase tracking-widest">
          Made in Mexico • Hecho en México
        </div>
      </motion.div>
    </div>
  );
};

export default LanguageGate;